import React from 'react';
import eulaSdc from '../../../assets/pdfs/eula-sdc.pdf';
import Data from '../../data';
import UI from '../../ui';
import Utils from '../../utils';
import AddCarrierHeader from '../AddCarrierHeader.component';

const { Carrier } = Data;
const { Section, SectionBody, Footer, Fineprint } = UI;
const { Session } = Utils;

const FedExEulaAgreement = ({
	completionCallback,
	onAcceptEula,
	enterpriseLocations,
	backAction,
}) => {
	const onAcceptButtonClick = () => {
		onAcceptEula(true);
	};

	const onCancelButtonClick = () => {
		completionCallback(false);
	};

	const renderPdf = () => {
		return (
			<iframe
				className="fedex-eula-iframe"
				title="Stamps.com FedEx EULA"
				src={eulaSdc}
			/>
		);
	};

	return (
		<div className="common-carrier-fedex-eula">
			<Section>
				<AddCarrierHeader
					title="FedEx End-User License Agreement"
					carrier={Carrier.FedEx}
					subtitle="To start shipping with FedEx, you must first agree to the FedEx End-User License Agreement:"
					dataqa="EULA"
				/>
				<Fineprint>
					FedEx service marks are owned by Federal Express Corporation and are
					used by permission.
				</Fineprint>
				<SectionBody dataqa="fedex-eula-body-wrapper">
					{renderPdf()}
				</SectionBody>
				<Footer
					primary={{
						label: 'I Agree',
						onClick: onAcceptButtonClick,
						dataqa: 'fedex-eula-primary-btn',
					}}
					secondary={{
						label: enterpriseLocations ? 'Start Over' : 'Cancel',
						onClick: onCancelButtonClick,
						dataqa: 'fedex-eula-secondary-btn',
					}}
					backAction={backAction ?? (() => completionCallback(false))}
				/>
			</Section>
		</div>
	);
};

export default FedExEulaAgreement;
